import './LoginContainerComponent.css'
import myrisIcon from '../../assets/myris-tech-icon.png';

const LoginHeader = () => {
  return (
    <div className="interior-box">
      <div className="login-headers">
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px", marginTop: "45px"}}>                
          <img src={myrisIcon} alt="Google" style={{ height: '50px' }} />
          <h1>Myris Tech</h1>
        </div>
        <h1 style={{ marginTop: "0px" }}>Login</h1>
        <h3 style={{ color:"rgb(87, 87, 87)" }}>Sign in to your account</h3>
      </div>
    </div>
  );
}

export default LoginHeader;